<template>
    <div class="m-2 text-center">
        <img class="empty-list-image-container" src="../../../public/img/svg/empty_box.svg" />
        <div class="empty-list-text-container">
            <strong>{{Text}} </strong>
        </div>
    </div>
</template>

<script type="text/javascript">

    export default {
        name: 'EmptyListImages',

        props: {
            Text: {
                type: String,
                default: 'Nu exista date'
            },
        },

        components: {
        },
        data: () => {
            return {
            }
        },
        computed:
        {
        },
        methods: {
        }
    }

</script>
